export const PRO_APP_TRANSLATION_DOMAINS = [
  'analyze',
  'analyze-admin',
  'analyzes-admin',
  'check-list',
  'change-password',
  'clock-and-visit-operation',
  'client',
  'client-admin-form',
  'client-notifications',
  'clients',
  'commitments-admin',
  'commitment-admin-form',
  'commitments-schedule',
  'credit-purchase',
  'email-validation',
  'equipment-admin-form',
  'equipments-admin',
  'lead',
  'lead-admin-form',
  'lead-order',
  'lead-orders',
  'leads',
  'leads-notifications',
  'local-admin-form',
  'local-equipment-admin',
  'local-equipments-admin',
  'local-stock-admin',
  'login',
  'minimalist-list',
  'monitoring',
  'my-leads',
  'navigation-menu',
  'notification',
  'notifications',
  'parameter-field',
  'payment',
  'places',
  'places-admin',
  'product-admin',
  'product-admin-form',
  'product-suggestion-rules-admin',
  'products-admin',
  'protocol-admin-form',
  'protocols-admin',
  'pool-admin-form',
  'pools-admin',
  'qr-code',
  'qr-code-scanner',
  'questionnaire',
  'rule-config',
  'report-problems',
  'reports',
  'selfie-photo-verification',
  'services-performed',
  'signup-link-form',
  'signup-standard',
  'special-treatment-details-admin',
  'special-treatment-details-admin-form',
  'stock-movements',
  'support-chat',
  'tasks-admin',
  'transference-admin-form',
  'transference-create',
  'transferences',
  'user-admin-form',
  'users-admin',
  'visit',
];
